/**
 * Twitterシェア
 */
export default class snsShare {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.elClass = '.c-twShare';
    this.el = document.querySelectorAll(this.elClass);

    if (this.el) {
      this.init();
    }
  }

  /**
   * 初期化
   */
  init() {
    //this.hashTag = '#ファミマの刀剣乱舞コラボチューハイのんでみた';
    this.hashTag = '#ファミマの刀剣乱舞チューハイで本丸時間';

    this.el.forEach((el) => {
      /** twitter */
      el.setAttribute('href', 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(this.hashTag));
      el.setAttribute('target', '_blank');
    });
  }
}